<script setup lang="ts">
import { computed } from 'vue'
import type { PdfViewerProps } from '#src/interfaces'

const { src, showToolbar = true, title = 'PDF Document Viewer' } = defineProps<PdfViewerProps>()

const iframeSrc = computed(() => {
  if (!showToolbar || src.includes('#toolbar=1')) {
    return src
  }

  return `${src}#toolbar=1`
})
</script>

<template>
  <iframe class="pdf-viewer" :src="iframeSrc" :title="title" />
</template>

<style lang="scss" scoped>
.pdf-viewer {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
